import { Session } from "@models/ISchema";
import { Week } from "@modules/sections/ISections";
import { Week as linkDataWeek } from "../context/linkData.reducer";

const intervalAdapter =
  (sessionsWeeksById: { [key: string]: boolean }) =>
  (interval: Week): Week => ({
    ...interval,
    checked: interval.id in sessionsWeeksById,
    highlight: false,
  });

const intervalsAdapter = (linkWeeks: Week[], session: Session): linkDataWeek[] => {
  const sessionWeeksById = (session?.assignment?.intervals ?? []).reduce(
    (acc: { [key: string]: boolean }, week) => ({ ...acc, [week.id]: true }),
    {},
  );
  return (linkWeeks ?? []).map(intervalAdapter(sessionWeeksById));
};

export default intervalsAdapter;
